import type { OnDestroy, Renderer2 } from '@angular/core';
import { Injectable, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PopoverGlobalService implements OnDestroy {
    private renderer: Renderer2 = this.rendererFactory2.createRenderer(null, null);

    private readonly removePointerDown: () => void;
    private readonly removePointerUp: () => void;

    private _isPointerDown: boolean;

    get isPointerDown(): boolean {
        return this._isPointerDown;
    }

    constructor(private rendererFactory2: RendererFactory2) {
        this.removePointerDown = this.renderer.listen('document', 'pointerdown', () => this._isPointerDown = true);
        this.removePointerUp = this.renderer.listen('document', 'pointerup', () => this._isPointerDown = false);
    }

    ngOnDestroy(): void {
        this.removePointerUp?.();
        this.removePointerDown?.();
    }
}
